<template>
  <div class="login-page bg-f">
    <div class="brand-logo">
      <div class="crow" />
    </div>
        <van-form class="login-form" @submit="loginSubmit()">
        <van-field
          v-model="account"
          class="position-relative"
          name="账号"
          placeholder="请输入账号"
        >
          <template #left-icon>
            <mobile-icon icon="username" class-name="form-icon" />
          </template>
        </van-field>
        <van-field
          v-model="password"
          class="position-relative"
          type="password"
          name="密码"
          placeholder="请输入密码"
        >
          <template #left-icon>
            <mobile-icon icon="password" class-name="form-icon" />
          </template>
        </van-field>
        <div>
          <van-button class="submit-button" round block type="info" :loading="loginloading" native-type="submit" loading-text="加载中..." :disabled="!checked">登录</van-button>
          <mobile-text class="pad-v-16" text="忘记密码" @click.native="wjmm" />
          <van-checkbox v-model="checked" @click="ysxy" icon-size="16px" checked-color="#3395F8">
            <mobile-text text="我已阅读并同意服务协议、隐私权政策" />
          </van-checkbox>
 <!--        <div>{{ts}}</div> -->
        </div>

      </van-form>
    <van-dialog v-model="show" title="修改密码" :before-close="beforeClose" @confirm="handleConfirm">
      <van-form ref="myform" >
        <!-- 输入密码 -->
        <van-field v-model="formmm.oldPassword" style="padding: 10px 10px 10px 10px"
                   type="password"
                   label="旧密码"
                   placeholder="请输入旧密码"
                   :rules="[
            { required: true, message: '请输入旧密码' }
          ]"
        />
        <van-field v-model="formmm.newPassword" style="padding: 10px 10px 10px 10px"
                   type="password"
                   label="新密码"
                   placeholder="请输入新密码"
                   :rules="[
            { required: true, message: '请输入新密码' }
          ]"
        />
        <van-field v-model="formmm.confirmPassword" style="padding: 10px 10px 10px 10px"
                   type="password"
                   label="新密码确认"
                   placeholder="请再次输入新密码"
                   :rules="[
            { required: true, message: '请输入新密码' }
          ]"
        >
        </van-field>
        <van-row>
          <van-col span="24">
            <span style="color: red;font-size: 14px;padding: 5px 5px 5px 5px">{{pwdesc}}</span>
          </van-col>
        </van-row>
      </van-form>
    </van-dialog>

    <van-dialog  title="用户服务协议和隐私政策" v-model="Visiblexy" :show-confirm-button="false" :show-cancel-button="false">
      <div style="height: 400px">
        <iframe style="height: 100%" :src="ysxyurl"></iframe>
      </div>
      <div style="text-align:center" >
        <van-button type="default" @click="cancelxy" style="width: 49%;height: 40px;">取消</van-button>
        <van-button type="default" @click="confirmxy" style="width: 49%;height: 40px;">同意</van-button>
      </div>
    </van-dialog>
    <div v-if="false" class="tips-container">
      <div class="tips"><a target='_blank' href='https://www.entss.cn/file-download-345-left.html'><mobile-icon icon="android" /> 安卓版本下载 </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a target='_blank' href='https://testflight.apple.com/join/Rf3tFyRF'><mobile-icon icon="IOS" />IOS版本下载</a></div>
    </div>
  </div>
</template>

<script>
import {Dialog, Notify, Toast} from 'vant'
import { encrypt, decrypt } from '../../utils/jsencrypt'
import global from '../../../static/gloabvar'
export default {
  data () {
    return {
      redirect: undefined,
      isBlur: false,
      checked: true,
      bindshow: false,
      bindtext: '首次登录请绑定App',
      account: '',
      ts: '',
      password: '',
      qywxid: null,
      smsCode: '',
      isFocus: false,
      isFocus1: false,
      schoolcode: '',
      loginloading: false,
      smsloading: false,
      uppwloading: false,
      smsloadtext: '正在发送...',
      ysxyurl: this.$global.assetsPublicPath + '/static/ysxy.html',
      code: '',
      show: false,
      pattern: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{8,18}/,
      regularemail: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
      formmm: {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
        email: null
      },
      bindform: {
        mobile: null,
        smsCode: null,
        code: null,
        appid: null
      },
      Visible: false,
      formzh: {
        account: null,
        phone: null,
        yzm: null
      },
      showyzm: true,
      yzmtimes: 60,
      zhmm: true,
      formmm2: {
        account: null,
        phone: null,
        yzm: null,
        xmm: null,
        qrmm: null
      },
      showemail: false,
      Visiblexy: false,
      showcode: true,
      count: '',
      timer: null,
      checklogin: false,
      sysuser: {},
      pwdesc: null
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created () {
    let code = this.GetParam(window.location.href.split('#')[0], 'code')
    this.ts += '\ncode = ' + code
    // 判断用户是否点击了注销登录，如点击了注销则不再判断微信直接登录
    // let cancellation = this.GetParam(window.location.href,"cancellation");
    if (!code) {
      if (this.$global.casEnable) {
      } else {
        // 判断app访问，设置appid
        var ua = navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          this.loginloading = true
          this.bindtext = '首次登录请绑定微信'
          this.isBlur = true
          this.wxauth()
        } else {

        }
      }
    } else {
      this.code = code
      this.isBlur = true
      this.wxlogin()
    }
    // let token = localStorage.getItem('Token');
    // let that = this;
    // if(null!=token) {
    //   this.$ajax.get('/appapi/getInfo').then(function (res) {
    //     if (res.code == 200 && token) {
    //       let user = res.user;
    //       localStorage.setItem('facecheck', 'true');
    //       that.$router.push({path: that.redirect || "/work"}).catch(() => {
    //       })
    //     }

    //   });
    // }
  },
  methods: {
    async login () {
      localStorage.clear()
      const queryParams = {
        username: this.account,
        password: this.password,
        code: this.code,
        qywxid: this.qywxid,
        appid: this.bindform.appid
      }

      const res = await this.$ajax.post('/appapi/applogin', queryParams)
      if (res.code == 200) {
        let user = res.user
        this.sysuser = res.user
        localStorage.setItem('Token', res.token)
        this.$store.dispatch('setToken', res.token)
        localStorage.setItem('user', JSON.stringify(res.user))
        this.$store.dispatch('getInfo').then(res => {
          this.$router.push({path: '/work'}).catch(() => {
          })
        })

        this.loginloading = false
      } else {
        this.loginloading = false
      }
    },
    loginSubmit () {
      this.loginloading = true
      if (this.account == '' || this.password == '') {
        Notify({type: 'danger', message: '请填写账号和密码'})
        this.loginloading = false
      } else {
        this.login()
      }
    },
    deleteTap (val) {
      if (val == 0) {
        this.account = ''
      } else {
        this.password = ''
      }
    },

    lineChange (res) {
      if (res == 0) {
        this.isFocus = true
        this.isFocus1 = false
      } else {
        this.isFocus1 = true
        this.isFocus = false
      }
    },
    wxlogin () { // 通过code进行微信登录
      let that = this
      let params = {code: this.code, appid: this.bindform.appid}
      let wxrouterPath = localStorage.getItem('wxrouterPath')
      this.ts += '\nstart wxlogin: '
      localStorage.clear()
      this.$ajax.post('/appapi/qywxlogin', params).then(res => {
        this.ts += '\nstart qywxlogin: ' + res.token
        // console.log(res)
        if (res.token) {
          localStorage.setItem('Token', res.token)
          that.$store.dispatch('setToken', res.token)
          localStorage.setItem('user', JSON.stringify(res.user))
          that.$store.dispatch('getInfo').then(res => {
            that.$router.push({path: '/work'}).catch(() => {
            })
          })
        } else {
          that.qywxid = res.qywxid
          that.loginloading = false
        }
      })
      //   this.$ajax.post('/appapi/wechatlogin',params).then(function(res) {
      //     if (res.code == 200) {
      //       let user = res.user;

      //       localStorage.setItem('Token', user.token);
      //       localStorage.setItem('Identity', user.usertype);
      //       localStorage.setItem('user', JSON.stringify(user));
      //       localStorage.setItem('jxsysxy', '1');
      //       localStorage.setItem("weakPass", res.weakPass)
      //       //that.$router.push('/work');
      //       Notify({type: 'success', message: "已绑定，系统自动登录！"});
      //       if (wxrouterPath && that.bindform.appid == null) {
      //         that.loginloading = true;
      //         setTimeout(() => {
      //           that.loginloading = false;
      //           that.$router.push({path: wxrouterPath || "/work"}).catch(() => {
      //           });
      //         }, 1000);
      //       } else {
      //         that.loginloading = true;
      //         setTimeout(() => {
      //           that.loginloading = false;
      //           that.$router.push({path: that.redirect || "/work"}).catch(() => {
      //           });
      //         }, 1000);
      //       }
      //     }
      //   })
      //
    },

    wxauth () {
      let that = this
      this.ts += '\nstart wxauth redirect_uri '
      localStorage.clear()
      localStorage.removeItem('Token')
      this.$ajax.get('/appapi/qywxredict/' + this.$global.agentId).then(function (res) {
        if (res.code == 200) {
          if (res.redirect_uri != '') {
            window.location.href = res.redirect_uri
          }
        }
      })
    },

    GetParam (url, code) {
      url = url + ''
      let regstr = '/(\\?|\\&)' + code + '=([^\\&]+)/'
      let reg = eval(regstr)
      // eval可以将 regstr字符串转换为 正则表达式
      let result = url.match(reg)
      if (result && result[2]) {
        return result[2].replace('#/', '')
      }
    },

    beforeClose (action, done) {
      if (action === 'confirm') {
        return done(false)
      } else {
        // 重置表单
        this.formmm = {
          oldPassword: null,
          newPassword: null,
          confirmPassword: null,
          email: null
        }
        return done()
      }
    },
    handleConfirm () {
      if (this.formmm.newPassword != this.formmm.confirmPassword) {
        Notify({type: 'danger', message: '两次输入的新密码不一致！'})
        return
      }
      let oldPassword = this.formmm.oldPassword
      let newPassword = this.formmm.newPassword
      let email = this.formmm.email
      const data = {
        oldPassword,
        newPassword,
        email
      }
      let that = this
      this.$refs['myform']
        .validate()
        .then(() => {
          this.$ajax.post('/appapi/UpPasswd', data).then(response => {
            if (response.code == 500) {
              this.formmm = {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null,
                email: null
              }
              Notify({type: 'danger', message: response.msg})
            } else {
              this.show = false // 在这里手动的关闭弹窗
              Notify({type: 'success', message: '修改成功'})
              // 重置表单
              this.formmm = {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null,
                email: null
              }
              this.$ajax.get('/appapi/applogout?outtype=0').then(function (res) {
                if (res.code == 200) {
                  localStorage.clear()
                  localStorage.removeItem('Token')
                  location.href = that.$global.assetsPublicPath + '/login?cancellation=1'
                }
              })
            }
          })
        })
        .catch(() => {
        })
    },
    wjmm () {
      this.Visible = true
    },
    cancel () {
      this.Visible = false
    },
    pwdconfirm () {
      if (this.formmm2.xmm == null || this.formmm2.xmm == '') {
        Notify({type: 'danger', message: '请输入新密码！'})
        return
      }
      if (this.formmm2.qrmm != this.formmm2.xmm) {
        Notify({type: 'danger', message: '确认密码和新密码不一致！'})
        return
      }
      this.uppwloading = true
      let data = {account: this.formmm2.account, phone: this.formmm2.phone, yzm: this.formmm2.yzm, xmm: this.formmm2.xmm, qrmm: this.formmm2.qrmm}
      let that = this
      this.$ajax.post('/appapi/zhUpPasswd', data).then(response => {
        if (response.code == 200) {
          Notify({type: 'success', message: '修改成功！'})
          that.formmm2.xmm = null
          that.formmm2.qrmm = null
          that.formzh.account = null
          that.formzh.yzm = null
          that.zhmm = true
          that.Visible = false
          that.uppwloading = false
        } else {
          that.uppwloading = false
        }
      })
    },
    getyzm () {
      if (this.formzh.account == null || this.formzh.account == '') {
        Notify({type: 'danger', message: '请输入账号！'})
        return
      }
      let data = {account: this.formzh.account, phone: this.formzh.phone}
      this.smsloading = true
      let that = this
      this.$ajax.post('/appapi/getMMsmsCode', data).then(response => {
        if (response.code == 200) {
          Notify({type: 'success', message: '发送成功！'})
          that.showyzm = false
          that.smsloading = false
          that.timer = setInterval(() => {
            that.yzmtimes--
            if (that.yzmtimes === 0) {
              that.showyzm = true
              that.yzmtimes = 60
              clearInterval(that.timer)
            }
          }, 1000)
        } else {
          that.smsloading = false
        }
      })
    },
    hdconfirm () {
      if (this.formzh.account == null || this.formzh.account == '') {
        Notify({type: 'danger', message: '请输入账号！'})
        return
      }
      if (this.formzh.yzm == null || this.formzh.yzm == '') {
        Notify({type: 'danger', message: '请输入验证码！'})
        return
      }
      this.uppwloading = true
      let data = {account: this.formzh.account, yzm: this.formzh.yzm, phone: this.formzh.phone}
      let that = this
      this.$ajax.post('/appapi/checkYzm', data).then(response => {
        if (response.code == 200) {
          that.formmm2.account = that.formzh.account
          that.formmm2.phone = that.formzh.phone
          that.formmm2.yzm = that.formzh.yzm
          that.zhmm = false
          that.uppwloading = false
        } else {
          that.uppwloading = false
        }
      })
    },
    ysxy () {
      this.Visiblexy = true
    },
    cancelxy () {
      this.Visiblexy = false
      localStorage.setItem('jxsysxy', '2')
    },
    confirmxy () {
      this.Visiblexy = false
      this.checked = true
      localStorage.setItem('jxsysxy', '1')
    },
    isMobile () {
      let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
      let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (!isAndroid && !isiOS) {
        return false
      }
      return true
    },
    getRegistrationID (val) {
      if (val != false) {
        this.bindform.appid = val
        this.wxlogin()
      }
    }
  },

  mounted () {}
}
</script>

<style scoped>
.brand-logo {
  height: 180px;
  width: 100%;
  background: url('../../assets/images/login.png')no-repeat top center;
  background-size: 100% auto;
  position: relative;
}
.logo-icon {
  border: none;
  width: 261px;
  height: 69px;
  border-radius: 0 !important;
  overflow: unset !important;
}
.crow {
  box-sizing: border-box;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-bottom: 10px solid #FFFFFF;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -10px;
}
.login-form {
  margin-top: 25px;
  box-sizing: border-box;
  padding: 0 35px;
}
.login-form .van-cell {
  padding: 0;
  margin-bottom: 20px;
}
.login-form .van-cell /deep/ .van-field__control {
  box-sizing: border-box;
  border-radius: 20px;
  height: 40px;
  border: 1px solid #EEEEEE;
  padding: 0 40px;
}
.login-form .van-cell /deep/ .van-field__error-message {
  box-sizing: border-box;
  padding: 0 16px;
}
.login-page {
  min-height: 100vh;
  background-color: #FFFFFF;
}
.login-form .van-cell::after {
  display: none;
}
.form-icon {
  width: 18px;
  height: 18px;
  position: absolute;
  color: #999999;
  top: 50%;
  left: 18px;
  margin-top: -9px;
  z-index: 999;
  fill: currentColor;
}
.submit-button {
  height: 40px;
  background-color: #3395F8;
  border-color: transparent;
}
.tips-container {
  width: 100%;
  position: absolute;
  bottom: 40px;
  display: flex;
}
.tips {
  text-align: center;
  font-size: 12px;
  color: #666666;
  line-height: 18px;
}
.van-field-button {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 20px;
  height: 40px;
  border: 1px solid #EEEEEE;
  padding: 0 30px;
  background-color: #3395F8;
}
</style>



// WEBPACK FOOTER //
// src/views/Login/index.vue